import styled from 'styled-components';

export const Container = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  width: 110px;
  flex-direction: column;
  border-radius: 10px;
  margin: 0 auto;
  box-shadow: 3px 2px 6px 0px rgba(0, 0, 0, 0.12);
`;
export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
  padding: 5px;
  height: 72px;
  border-radius: 0px 0px 10px 10px;
  background: #f5f5f5;

  h5 {
    margin: 0;
    color: #4d4d4c;
    text-align: center;
    font-family: Poppins;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    width: 100%;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    box-orient: vertical;
  }

  span {
    color: #4d4d4c;
    text-align: center;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
  }
`;

export const ProductImage = styled.img`
  width: 110px;
  height: 110px;
  border-radius: 10px 10px 0 0;
  object-fit: cover;
`;

export const ProductPrice = styled.span`
  font-weight: 12px;
`;

export const ProductName = styled.span`
  font-weight: bold;
  font-weight: 14px;

  line-height: 15px;
`;

export const CountBadge = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -5px;
  right: -5px;
  border-radius: 50%;
  background: #ff2b3a;
  color: #fff;
  font-weight: bold;
`;
